import first from '../img/banner/1.jpg'
import second from '../img/banner/2.jpg';
import third from '../img/banner/3.png';

export default [
	{
		title: 'Architecture',
		description: 'CRAFTING SPACES FOR A BETTER LIFESTYLE',
		urls: first,
	},
	{
		title: 'Architecture',
		description: 'DREAMS UNDER CONSTRUCTION',
		urls: second,
	},
	{
		title: 'Architecture',
		description: 'CREATIVITY WELL DEFINED',
		urls: third,
	},
];